import { FormsFieldPreset, FormPlugin } from '@wix/forms-common'
import { GeneralText } from '../../general-fields/definitions/general-text'
import { CRM_TYPES, CRM_TAGS } from '../../../../../../constants/crm-types-tags'
import { iconNames } from '../../icons/types'
import { CATEGORIES } from '../../../../../../panels/manage-fields-panel/constants/manage-fields-constants'

export class Address extends GeneralText {
  public get customFields() {
    return this.base.customFields
  }

  public get crmTag() {
    return CRM_TAGS.OTHER
  }

  protected get icon() {
    return iconNames.address
  }

  public get fieldType(): FieldPreset {
    return FormsFieldPreset.ADDRESS
  }

  public get crmType() {
    return CRM_TYPES.ADDRESS
  }

  protected get data(): any {
    return {
      textType: 'text',
      placeholder: this.translate(`fieldTypes.${this.fieldType}`),
    }
  }

  protected get renderConfig() {
    return {
      [FormPlugin.FORM_BUILDER]: {
        addFieldPanelData: {
          category: CATEGORIES.contact,
        },
      },
      [FormPlugin.REGISTRATION_FORM]: {
        addFieldPanelData: { category: CATEGORIES.none },
      },
    }
  }
}
